import {Box, Title} from "@mantine/core";
import picture from "../../images/imgCloud.png";
import UserInputForm from "./userInputForm";
import {useState} from "react";

const InputPage = () => {
    const [isComplete, setIsComplete] = useState(false);
    const processHandler = (complete) => {
        setIsComplete(complete);
    };
    return (
        <div
            className={`flex flex-col  min-w-full h-screen bg-gradient-to-b from-greenThree to-yellow4 ${ !isComplete ? 'justify-between': 'justify-center'}`}>
            <div className="flex flex-col justify-center items-center h-3/5 ">
                <img src={picture} alt="عکس تقویم" width={200} height={180}/>
                {isComplete &&
                    <p className="mt-3 drop-shadow-textshadow font-bold text-2xl"> فایل شما با موفقیت ثبت شد</p>}
            </div>
            {!isComplete && <Box className="  rounded-t-2xl bg-white py-6  p-4 ">
                <Title className="text-xl text-right "> بارگذاری</Title>
                <UserInputForm setUploadComplete={processHandler}/>
            </Box>}
        </div>
    )

}
export default InputPage;